<template>
  <el-dialog
    :title="oneStepOkType === 1 ? '手动一键已阅无误' : '系统批量已阅无误'"
    :visible="currentVisible"
    width="80%"
    :close-on-click-modal="false"
    class="dialog-transedit"
    @close="close"
  >
    <el-row :span="24">
      <el-col :span="24">
        <span v-if="oneStepOkType === 2">
          当前审核人审核的句子您确认无误≥30%，可信度较高。
          <br />
          <br />
        </span>
        <span>
          是否将
          <span style="color: blue">“{{ name }}”</span>
          当前提交的剩余
          <span>{{ oneStepOkText }}的句子</span>
          <span style="color: red">（共{{ oneStepOkNum }}句）</span>
        </span>
        <span style="color: blue">批量标记为已阅无误？</span>
      </el-col>
    </el-row>
    <br />
    <el-row :gutter="24">
      <el-col>
        <el-checkbox-group @change="passChange" v-model="oneStepOkPassList">
          <el-checkbox label="0" style="height: 32px">
            后续自动
            <span style="font-weight: bold">“已阅无误”</span>
            （仅限风险等级0）
          </el-checkbox>
          <br />
          <el-checkbox label="1" style="height: 32px">
            当前以及后续自动
            <span style="font-weight: bold">“已阅无误”</span>
            （仅限风险等级0/风险等级1）
          </el-checkbox>
          <br />
          <el-checkbox label="2" style="height: 32px">
            当前以及后续自动
            <span style="font-weight: bold">“已阅无误”</span>
            （仅限风险等级0/风险等级1/风险等级2）
          </el-checkbox>
          <br />
          <el-checkbox label="3" style="height: 32px">
            当前以及后续自动
            <span style="font-weight: bold">“已阅无误”</span>
            （仅限风险等级0/风险等级1/风险等级2/风险等级3）
          </el-checkbox>
        </el-checkbox-group>
      </el-col>
    </el-row>
    <div class="btn-item" v-if="isQcOperate">
      <!--判断提交还是修改-->
      <el-button
        type="primary"
        :loading="isLoad"
        @click.stop="submitOneStepOk()"
      >
        确定批量已阅无误
      </el-button>
      <el-button type="info" :loading="isLoad" @click.stop="close">
        我再想想
        <span v-if="oneStepOkType === 2">(此译员全手动处理)</span>
      </el-button>
    </div>
  </el-dialog>
</template>

<script>
import { riskNumTj, passAllQcTask } from '@/api/qc/qcflow';
import { statistics } from '@/api/dot/flow';

export default {
  props: [
    'visible', // 弹窗的触发逻辑，非显示状态
    'orderId',
    'flowId',
    'searchQcTaskId',
    'queryQcTaskId',
    'taskType',
    'lastAuditerId',
    'name',
    'isQcOperate', // 权限判断是否展示操作按钮
    'staParams',
    'userInfo',
  ],
  data() {
    return {
      currentVisible: false,
      oneStepOkType: '', //一键已阅无误类型 2：系统，1手动
      oneStepOkNum: 0, //译员风险等级0的句子数
      oneStepOkPass: false, //是否自动已阅无误
      oneStepOkText: '风险等级为0',
      oneStepOkPassList: [], //是否自动已阅无误
      oneStepOkPassNum: { oneNum: 0, twoNum: 0, threeNum: 0, zeroNum: 0 },
    };
  },
  watch: {
    visible(val) {
      if (val) {
        this.getData();
      }
    },
  },
  methods: {
    // 拉取弹窗数据，并判断是否显示弹窗
    getData() {
      riskNumTj({
        trId: this.lastAuditerId,
        orderId: this.orderId,
        flowId: this.flowId,
        qcTaskId: this.searchQcTaskId || this.queryQcTaskId,
      }).then((res) => {
        const data = res.data?.data;
        this.oneStepOkType = 1;
        this.oneStepOkPassNum = data?.sentenceTjDto;
        this.oneStepOkPassList = [];
        this.oneStepOkPassList[0] = '' + data?.checkType;
        this.getOneStepOkText(this.oneStepOkPassList[0]);
        this.currentVisible = true;
      });
      statistics(
        Object.assign(
          {
            event_name: '一键已阅无误',
            event_type: 'click',
          },
          this.staParams,
        ),
      );
    },

    // 复选框勾选触发
    passChange() {
      if (this.oneStepOkPassList.length > 1) {
        this.oneStepOkPassList.splice(0, 1);
      }
      this.getOneStepOkText(this.oneStepOkPassList[0]);
    },

    // 风险等级文案处理
    getOneStepOkText(checkType) {
      const { zeroNum, oneNum, twoNum, threeNum } = this.oneStepOkPassNum;
      if (checkType === '1') {
        this.oneStepOkText = '风险等级为0/1';
        this.oneStepOkNum = zeroNum + oneNum;
      } else if (checkType === '2') {
        this.oneStepOkText = '风险等级为0/1/2';
        this.oneStepOkNum = zeroNum + oneNum + twoNum;
      } else if (checkType === '3') {
        this.oneStepOkText = '风险等级为0/1/2/3';
        this.oneStepOkNum = zeroNum + oneNum + twoNum + threeNum;
      } else {
        this.oneStepOkText = '风险等级为0';
        this.oneStepOkNum = zeroNum;
      }
    },

    // 确定批量已阅无误提交
    submitOneStepOk() {
      this.isLoad = true;
      let riskLevel = this.oneStepOkPassList[0];
      if (riskLevel === null || riskLevel < 0) {
        riskLevel = -2;
      }
      // taskType 1为主质控，可以从搜索里去拿质控ID，不然就从链接上取
      let qcTaskId = this.queryQcTaskId;
      if (Number(this.taskType) === 1) {
        qcTaskId = this.searchQcTaskId || this.queryQcTaskId;
      }
      const params = {
        flowId: this.flowId,
        lastReviewer: this.lastAuditerId,
        riskLevel: riskLevel || -2,
        qcMode: this.oneStepOkType,
        qcTaskId: qcTaskId,
        operateQcTaskId: this.queryQcTaskId,
        operateQcId: this.userInfo?.staffId,
      };
      // 一键已阅无误
      passAllQcTask(params).then((res) => {
        this.close();
        this.$emit('one-step-ok-done');
      });
    },
    // 关闭弹窗
    close() {
      this.isLoad = false;
      this.currentVisible = false;
      this.$emit('update:visible', false);
    },
  },
};
</script>

<style lang="scss" scoped>
.dialog-transedit {
  .btn-item {
    margin-top: 2vh;
    text-align: center;
  }
}
</style>
